// extracted by mini-css-extract-plugin
export var card = "_m4-1";
export var summary = "_m4-0";